<div class="dialog-content-wrapper" cslPerfectScrollbar>
  <div mat-dialog-title>
    <span class="title dialog-title text-truncate">
      <span i18n>Мастер отверстий</span>
      {{ fastenerTitleName }}
    </span>

    <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="p-0 pb-0 m-0" cslPerfectScrollbar>
    <ng-container>
      <mat-horizontal-stepper [linear]="true" #stepper>
        <mat-step #schemaListStep [completed]="false" [editable]="false">
          <ng-template i18n matStepLabel>Выберите отверстие</ng-template>

          <csl-fastener-selection
            cslPerfectScrollbar
            [schemas]="data.holeSchemas"
            [fastenerSets]="data.holeSetSchemas"
            (formChanged)="onFastenerChanged($event)"
            class="flex flex-col items-stretch"
            >Loading…
          </csl-fastener-selection>
        </mat-step>

        <mat-step [completed]="false" [editable]="false" #sideSelectStep>
          <ng-template i18n matStepLabel>Выберите торец</ng-template>

          <div
            class="flex flex-col space-y-4 w-full h-full min-h-full min-w-full max-h-full max-w-full overflow-hidden">
            <button
              class="mx-10 h-6 bg-red-600 hover:bg-red-500 transition duration-200 ease-in-out rounded"
              aria-label="Верхний"
              (click)="onSideChanged('tc')"></button>

            <div class="flex flex-row items-center flex-auto w-full overflow-hidden space-x-4">
              <button
                class="w-6 h-full bg-red-600 hover:bg-red-500 transition duration-200 ease-in-out rounded"
                aria-label="Левый"
                (click)="onSideChanged('lc')"></button>

              <div class="flex-auto overflow-hidden">
                <csl-countertop-schema
                  #edgeSchema
                  class="h-[400px] w-[700px] overflow-hidden m-auto block"></csl-countertop-schema>
              </div>

              <button
                class="w-6 h-full bg-red-600 hover:bg-red-500 transition duration-200 ease-in-out rounded"
                aria-label="Правый"
                (click)="onSideChanged('rc')"></button>
            </div>
            <button
              class="mx-10 h-6 bg-red-600 hover:bg-red-500 transition duration-200 ease-in-out rounded"
              aria-label="Нижний"
              (click)="onSideChanged('bc')"></button>
          </div>
        </mat-step>

        <mat-step [completed]="false" [editable]="false" #basePointSelectStep>
          <ng-template i18n matStepLabel>Выберите базовую точку</ng-template>

          <div class="flex flex-col items-stretch w-full h-full">
            <ng-container *ngIf="stepper.selectedIndex === 2">
              <csl-countertop-fastener-base-point-select
                #basePointSelect
                [defaultMirrorAxis]="defaultMirrorAxis"
                [availablePlate]="data.availablePlate"
                [mainMaterialThickness]="data.mainMaterialThickness"
                [side]="newHolesSide"
                [countertop]="data.countertop"
                [fastener]="selectedFastener"
                (formChanged)="onBasePointChanged($event)"
                class="flex flex-auto flex-col"></csl-countertop-fastener-base-point-select>
            </ng-container>

            <mat-divider></mat-divider>

            <div class="flex flex-row gap-2 pt-4 -mb-2 -mx-2 justify-end">
              <button data-testid="addDrill" i18n mat-raised-button color="accent" (click)="saveFastener()"
                >ДОБАВИТЬ</button
              >
              <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
              <!-- <button i18n mat-raised-button (click)="stepper.reset()">ИЗМЕНИТЬ</button> -->
            </div>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </ng-container>
  </div>
</div>
